import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientAccountContainer from "../../../components/client/account/ClientAccountContatiner";

//클라이언트 계정 메인 페이지
const ClientAccountMainPage: React.FC = () => {
    return (
        <ClientLayout>
            {/*클라이언트 계정*/}
            <ClientAccountContainer/>
        </ClientLayout>
    )
}
export default ClientAccountMainPage;